import { AbstractControl, Validator } from '@angular/forms';
export function ValidateAutoCompleteSelect(control: AbstractControl) {

  if (!control.value || control.value === '' || typeof control.value === 'string') {
    return { validAutoCompleteSelect: true };
  }

  return null;
}
